import { GLServiceBase, ServiceRoute } from "commonui";
import { IUnitListManager } from "./interface";
import {
	CreateUnitRequestModel,
	EditUnitRequestModel,
	VCSLevelUnitResponseModel,
	DisableUnitRequestModel,
	PDFExportModel,
	UnitAssociationModel
} from "./model";

class UnitListServiceClass extends GLServiceBase<any, any> implements IUnitListManager {
	serviceRoute: ServiceRoute = { prefix: "content/v1/vcslevel" };

	createUnit(model: CreateUnitRequestModel): Promise<boolean> {
		return this.create(model, undefined);
	}

	editUnit(model: EditUnitRequestModel): Promise<boolean> {
		return this.update(model, undefined);
	}

	getVCSLevelUnits(params?): Promise<VCSLevelUnitResponseModel[]> {
		return this.get(params);
	}

	toggleDisable(model: DisableUnitRequestModel): Promise<boolean> {
		return this.update("disableUnit", model);
	}

	deleteLevel(levelId: number, params?: any): Promise<boolean> {
		return this.delete("{levelId}", { levelId, ...params });
	}

	getUnitAssociations(levelId: number): Promise<UnitAssociationModel> {
		return this.get("{levelId}/associations", { levelId });
	}

	exportOverViewPDF(model: PDFExportModel): Promise<any> {
		return this.getBlob("unitoverviews/pdf", model);
	}
}

export const UnitListManagerService = () => new UnitListServiceClass();
